import axiosInstance from "../Axios";
const getUserHierarchy = async (userId = null) => {
  try {
    const params = userId ? { id: userId } : {};
    return axiosInstance.get("/organization-hierarchy", { params });
  } catch (error) {
    console.error("Error fetching organization hierarchy:", error);
    throw error;
  }
};
const getActiveUsers = async () => {
  return axiosInstance.get("/users", { params: { _UserStatus: 1 } });
};

// Fetches employees filtered by Employee Status ("active" -> _UserStatus=1,
// "inactive" -> _UserStatus=0, "all"/anything else -> no filter, so both are
// returned) and, optionally, by the common State filter (resolved backend-
// side through the same Office Location/Office Location History logic the
// Compliance module's other reports already use) - the same GET /users
// endpoint getActiveUsers() above already uses, generalized so a status-
// and-state-dependent employee picker (Compliance Form C/F/15) can ask the
// backend for exactly the employees it should offer, instead of fetching
// everyone and filtering in the browser.
const getUsersByStatus = async (status, stateId) => {
  const params = {};
  if (status === "active") params._UserStatus = 1;
  else if (status === "inactive") params._UserStatus = 0;
  if (stateId) params.stateId = stateId;
  return axiosInstance.get("/users", { params });
};

const getReporteeUserHierarchy = (userId = null) => {
  const params = userId ? { id: userId } : {};
  return axiosInstance.get("/users/my-users-hierarchy", { params });
};
export { getUserHierarchy, getActiveUsers, getUsersByStatus, getReporteeUserHierarchy };
